export default function SkeletonShimmer() {
  return (
    <div className="shimmer-wrapper">
      <div className="shimmer"></div>
    </div>
  );
}
